// Config dispositivi (stampanti, cassetti, terminali) ricordata per negozio,
// così al cambio negozio si ritrova l'ultima scelta fatta su questo device.
const STORAGE_KEY = "pos-shop-device-config";

export const SHOP_DEVICE_FIELDS = [
	"fiscal_printer_id",
	"thermal_printer_id",
	"virtual_printer_id",
	"glory_id",
	"cashmatic_id",
	"pos_p17_id",
	"viva_terminal_id",
	"dojo_terminal_id",
	"check_fiscal_closure",
	"prebill_on_checkout",
];

function loadAll() {
	try {
		const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
		return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
	} catch (error) {
		console.error("Errore lettura config dispositivi per negozio", error);
		return {};
	}
}

export function pickShopDeviceConfig(config) {
	const result = {};
	for (const field of SHOP_DEVICE_FIELDS) {
		if (config && field in config) result[field] = config[field];
	}
	return result;
}

export function loadShopDeviceConfig(shopId) {
	if (!shopId) return null;
	const saved = loadAll()[shopId];
	return saved && typeof saved === "object" ? pickShopDeviceConfig(saved) : null;
}

export function saveShopDeviceConfig(shopId, config) {
	if (!shopId || !config) return;
	const all = loadAll();
	all[shopId] = pickShopDeviceConfig(config);
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
	} catch (error) {
		console.error("Errore salvataggio config dispositivi per negozio", error);
	}
}

export function emptyShopDeviceConfig() {
	return {
		fiscal_printer_id: null,
		thermal_printer_id: null,
		virtual_printer_id: null,
		glory_id: null,
		cashmatic_id: null,
		pos_p17_id: null,
		viva_terminal_id: "",
		dojo_terminal_id: "",
		check_fiscal_closure: 0,
		prebill_on_checkout: 0,
	};
}
